import { Link } from 'react-router-dom'
import { ArrowLeftIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'

const LAST_UPDATED = '2026-06-25'

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow p-8 space-y-6">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
          <ArrowLeftIcon className="h-4 w-4" />
          Back
        </Link>

        <div className="flex items-start gap-3 bg-yellow-50 border border-yellow-200 rounded-md p-4">
          <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600 shrink-0 mt-0.5" />
          <p className="text-sm text-yellow-800">
            <strong>Draft — pending legal review.</strong> This is a standard template and has not
            yet been reviewed by counsel. Do not rely on it as a final legal document.
          </p>
        </div>

        <div>
          <h1 className="text-2xl font-bold text-gray-900">Privacy Policy</h1>
          <p className="text-sm text-gray-500 mt-1">Last updated: {LAST_UPDATED}</p>
        </div>

        <section className="space-y-4 text-sm text-gray-700">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">1. Data We Collect</h2>
            <p>
              We collect information you provide directly (account details, profile information,
              content you publish) and information generated by your use of the Service
              (portfolios, trading signals, transactions, subscriptions, tips, and analytics
              events).
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">2. How We Use Your Data</h2>
            <p>
              We use your data to operate and improve the Service, process payments, deliver
              content and notifications, and, where you've consented, for marketing and
              personalization. See your{' '}
              <Link to="/settings" className="text-primary-600 hover:underline">
                Settings
              </Link>{' '}
              page to manage these preferences.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">3. Third-Party Services</h2>
            <p>
              We share data with service providers as needed to operate the platform, including
              Stripe (payments and creator payouts), Sentry (error monitoring, configured to
              exclude personally identifiable information), and email/SMS providers for
              notifications you've opted into.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">4. Cookies</h2>
            <p>
              We use cookies necessary for authentication and, where you've consented, analytics
              cookies to understand how the Service is used.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">5. Your Rights</h2>
            <p>
              You can export a copy of your data, review and update your consent preferences, or
              request deletion of your account at any time from your{' '}
              <Link to="/settings" className="text-primary-600 hover:underline">
                Settings
              </Link>{' '}
              page. Account deletion requests are reviewed and processed; this does not happen
              instantly.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">6. Data Retention</h2>
            <p>
              We retain your data for as long as your account is active or as needed to comply
              with legal obligations, resolve disputes, and enforce our agreements.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">7. Contact</h2>
            <p>
              Questions about this Privacy Policy can be directed to our support team — see our{' '}
              <Link to="/faq" className="text-primary-600 hover:underline">
                FAQ
              </Link>{' '}
              for contact details, or review our{' '}
              <Link to="/terms" className="text-primary-600 hover:underline">
                Terms of Service
              </Link>{' '}
              for details on using the Service.
            </p>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Privacy
